export default __webpack_public_path__ + "static/media/head.c5469ea6.jpg";